import { combineReducers } from 'redux';
import { APIReducer } from 'store/apiReducer';
import {
    CONTEXT_FORM_TITRE_DETENTION,
    CONTEXT_CREER_TITRE_DETENTION,
    CONTEXT_MODIFIER_TITRE_DETENTION,
    CONTEXT_RENOUVELLEMENT_TITRE_DETENTION,
} from 'constants/apiUrls.constants';

const titreDetention = combineReducers({
    renouvellementAutorisationPossible: APIReducer.bind(
        null,
        CONTEXT_RENOUVELLEMENT_TITRE_DETENTION,
    ),
    form: APIReducer.bind(null, CONTEXT_FORM_TITRE_DETENTION),
    creer: APIReducer.bind(null, CONTEXT_CREER_TITRE_DETENTION),
    modifier: APIReducer.bind(null, CONTEXT_MODIFIER_TITRE_DETENTION),
});

export default titreDetention;
